import get from 'lodash/get';

const DEFAULT_RUN_PIPELINE_ERROR = 'An error has occurred.';
const READ_ONLY_WORKSPACE_RUN_PIPELINE_ERROR = 'Can not run pipelines on a read-only workspace';
const READ_ONLY_WORKSPACE_BACKEND_ERROR = 'cannot run pipelines on read-only workspaces';

const getFirstString = (value) => {
  if (typeof value === 'string') return value;

  if (Array.isArray(value)) {
    return value.map(getFirstString).find(Boolean) || '';
  }

  if (value && typeof value === 'object') {
    return Object.values(value).map(getFirstString).find(Boolean) || '';
  }

  return '';
};

const getBackendErrorMessage = (error) => {
  const possibleMessages = [
    get(error, 'message'),
    get(error, 'error'),
    get(error, 'result'),
    get(error, 'messages.json'),
    get(error, 'response.data.message'),
    get(error, 'response.data.messages.json'),
    error
  ];

  return possibleMessages.map(getFirstString).find(Boolean) || '';
};

const isReadOnlyWorkspaceRunPipelineError = (message) => (
  message.trim().replace(/\.$/, '').toLowerCase().includes(READ_ONLY_WORKSPACE_BACKEND_ERROR)
);

const getRunPipelineErrorMessage = (error) => {
  const errorMessage = getBackendErrorMessage(error);

  if (isReadOnlyWorkspaceRunPipelineError(errorMessage)) {
    return READ_ONLY_WORKSPACE_RUN_PIPELINE_ERROR;
  }

  return DEFAULT_RUN_PIPELINE_ERROR;
};

export default getRunPipelineErrorMessage;
